var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fix-height" },
    [
      _vm.multiple
        ? _c("q-field", {
            staticClass: "customAccident customTag",
            attrs: {
              "stack-label": "",
              filled: "",
              dense: _vm.dense,
              color: "orange-custom",
              label: _vm.convertLabel,
              disable: _vm.disabled || !_vm.editable,
              rules: [_vm.myRule],
            },
            scopedSlots: _vm._u(
              [
                _vm.label
                  ? {
                      key: "label",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row items-center all-pointer-events",
                            },
                            [
                              _c(
                                "b",
                                [
                                  !_vm.required
                                    ? _c("i", {
                                        staticClass:
                                          "pe-7s-note labelfrontIcon searchAreaLabelIcon",
                                      })
                                    : _vm._e(),
                                  _c(
                                    "font",
                                    { staticClass: "formLabelTitle" },
                                    [_vm._v(_vm._s(_vm.convertLabel))]
                                  ),
                                  _vm.required
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons labelfrontIcon text-requiredColor",
                                        },
                                        [_vm._v("check")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "control",
                  fn: function () {
                    return [
                      _vm._l(_vm.vValueList, function (item, idx) {
                        return _c("q-chip", {
                          key: idx,
                          staticClass: "all-pointer-events",
                          attrs: {
                            outline: "",
                            square: "",
                            dense: _vm.dense,
                            removable: _vm.editable && !_vm.disabled,
                            color: "light-blue",
                            label: _vm.nameFor(item),
                            title: _vm.nameFor(item),
                            clickable: "",
                          },
                          on: {
                            remove: function ($event) {
                              return _vm.removeItem(idx)
                            },
                            click: function ($event) {
                              return _vm.linkClick(item)
                            },
                          },
                        })
                      }),
                      _vm.editable && !_vm.disabled
                        ? _c("q-chip", {
                            attrs: {
                              dense: _vm.dense,
                              outline: "",
                              square: "",
                              clickable: "",
                              color: "orange",
                              "text-color": "white",
                              icon: "add",
                              label: "추가",
                            },
                            on: { click: _vm.search },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.vValueList,
              callback: function ($$v) {
                _vm.vValueList = $$v
              },
              expression: "vValueList",
            },
          })
        : _c("q-field", {
            ref: "customAccident",
            staticClass: "customAccident q-field--with-bottom",
            attrs: {
              dense: _vm.dense,
              "stack-label": "",
              filled: "",
              color: "orange-custom",
              label: _vm.convertLabel,
              disable: _vm.disabled || !_vm.editable,
              rules: !_vm.required ? null : [(val) => !!val || ""],
            },
            scopedSlots: _vm._u(
              [
                _vm.label
                  ? {
                      key: "label",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "row items-center all-pointer-events",
                            },
                            [
                              _c(
                                "b",
                                [
                                  !_vm.required
                                    ? _c("i", {
                                        staticClass:
                                          "pe-7s-note labelfrontIcon searchAreaLabelIcon",
                                      })
                                    : _vm._e(),
                                  _c(
                                    "font",
                                    { staticClass: "formLabelTitle" },
                                    [_vm._v(_vm._s(_vm.convertLabel))]
                                  ),
                                  _vm.required
                                    ? _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons labelfrontIcon text-requiredColor",
                                        },
                                        [_vm._v("check")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                {
                  key: "control",
                  fn: function () {
                    return [_vm._v(" " + _vm._s(_vm.valueText) + " ")]
                  },
                  proxy: true,
                },
                {
                  key: "append",
                  fn: function () {
                    return [
                      !_vm.disabled && _vm.editable
                        ? _c("q-icon", {
                            staticClass: "cursor-pointer",
                            attrs: { name: "search" },
                            on: { click: _vm.search },
                          })
                        : _vm._e(),
                      !_vm.disabled && _vm.editable
                        ? _c("q-icon", {
                            staticClass: "cursor-pointer",
                            attrs: { name: "close" },
                            on: { click: _vm.reset },
                          })
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.valueText,
              callback: function ($$v) {
                _vm.valueText = $$v
              },
              expression: "valueText",
            },
          }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }